// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__e5b0q","content":"RecentSearches_content__2UwTh"};